import { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import useTitle from '../../hooks/UseTitle';
import { PagesContext } from '../../contexts/PagesContext';
import MainContainer from './MainContainer';
import BlockData from '../../models/BlockData';
import { CategoriesContext } from '../../contexts/CategoriesContext';

function MainWithPageId(props:{ pageId: string }) {
  const { pageId } = props;
  const pagesContext = useContext(PagesContext);
  const { Get: getPage, pageDatas: datas, pageDataLoading } = pagesContext;
  // This means it is a edit page
  useEffect(() => {
    getPage(pageId);
  }, [pageId, getPage]);

  // ローディングしている段階では、ローディングバーを表示させます
  if (pageDataLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (datas == null) {
    return <></>;
  }

  const data = datas.find((d) => d.id === pageId);
  if (data == null) {
    return <></>;
  }
  const blocksData = data.params;

  if (blocksData == null) {
    return <></>;
  }

  return <MainContainer blocksData={blocksData} page={data} />;
}

const defaultEmptyBlocksData:BlockData[] = [];

function Main() {
  const params = useParams();

  const { requestCategoryList } = useContext(CategoriesContext);

  useTitle('ビルドセルフ');
  const { id } = params;

  useEffect(() => {
    requestCategoryList();
  }, [requestCategoryList]);

  if (id) {
    return <MainWithPageId pageId={id} />;
  }

  return <MainContainer blocksData={defaultEmptyBlocksData} />;
}

export default Main;
